"use client";

import { Typography } from "@mui/material";
import { theme } from "@/lib/theme";

interface FundingNoticeProps {
  children: React.ReactNode;
}

export const FundingNotice = ({ children }: FundingNoticeProps) => {
  return (
    <Typography
      variant="body1"
      component="div"
      sx={{
        color: theme.colors.purple,
        fontWeight: theme.fonts.weights.bold,
        textAlign: "center",
        marginBottom: 2,
        "& > p": {
          color: "inherit",
          fontWeight: "inherit",
          marginBottom: 2,
        },
      }}
    >
      {children}
    </Typography>
  );
};
